@import "../../global/mixin.scss";

@mixin icon-style($identity, $icon, $hover-icon: null) {
  .#{$pagination-prefix-cls}-#{$identity} {
    &::after {
      content: var($icon);
    }
    &:hover {
      &::after {
        @if ($hover-icon) {
          content: var($hover-icon);
        } @else {
          content: var($icon + "-hover");
        }
      }
    }
  }
}

$pagination-prefix-cls: "uui-pagination";

:host {
  --uui-pagination-default-color: var(--uui-theme-core-500);
  --uui-pagination-disabled-color: var(--uui-theme-variant-400);
  --uui-pagination-active-color: var(--uui-theme-core-600);
  --uui-pagination-hover-color: var(--uui-theme-secondary-500);
  --uui-pagination-line-height: var(--uui-dv-large-line-height);
}

:host {
  margin-top: 0;
  font-family: var(--uui-primary-font-family);
  font-weight: var(--uui-font-weight-normal);
  font-size: var(--uui-default-font-size);
  line-height: var(--uui-default-line-height);
  color: var(--uui-pagination-default-color);

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    .#{$pagination-prefix-cls}-item {
      &:hover {
        color: var(--uui-pagination-hover-color);
      }
    }
    .#{$pagination-prefix-cls}-item-active {
      background-color: var(--uui-theme-variant-800);
      color: var(--uui-pagination-active-color);

      &:hover {
        color: var(--uui-pagination-hover-colorr);
      }
    }

    li.disabled {
      pointer-events: none;
      color: var(--uui-pagination-disabled-color);
      text-decoration: none;
    }

    .#{$pagination-prefix-cls}-item,
    .#{$pagination-prefix-cls}-first,
    .#{$pagination-prefix-cls}-prev,
    .#{$pagination-prefix-cls}-next,
    .#{$pagination-prefix-cls}-jump-prev,
    .#{$pagination-prefix-cls}-jump-next {
      display: inline-block;
      margin: 0 5px;
      width: var(--uui-pagination-line-height);
      height: var(--uui-pagination-line-height);
      line-height: var(--uui-pagination-line-height);
      user-select: none;
      text-align: center;
      vertical-align: middle;
      list-style: none;
      border-radius: 50%;
      cursor: pointer;
      transition: var(--uui-short-transition);
      &:hover {
        font-weight: var(--uui-font-weight-normal);
        color: var(--uui-pagination-hover-color);
        text-decoration: underline;
      }

      .#{$pagination-prefix-cls}-item-link {
        &::after {
          display: flex;
          text-align: center;
          flex-direction: column;
          justify-content: center;
          position: relative;
          left: 0rem;
          top: 0.36rem;
        }
      }

      @include icon-style("button-left", --uui-icon-chevron-left);
      @include icon-style("button-right", --uui-icon-chevron-right);
      @include icon-style(
        "button-jump-prev-icon",
        --uui-icon-ellipsis-h,
        --uui-icon-chevron-double-left-hover
      );
      @include icon-style(
        "button-jump-next-icon",
        --uui-icon-ellipsis-h,
        --uui-icon-chevron-double-right-hover
      );
    }

    .#{$pagination-prefix-cls}-first,
    .#{$pagination-prefix-cls}-last {
      width: auto;
      text-decoration: underline;
      color: var(--uui-pagination-default-color);
    }
  }

  &::after {
    display: block;
    clear: both;
    height: 0;
    overflow: hidden;
    visibility: hidden;
    content: " ";
  }
}
